import { format } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';
import * as locales from 'date-fns/locale';

export function formatWithSystemLocale(isoString) {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const userLocale = navigator.language || 'en-US';
  const localeKey = userLocale.replace('-', '');

  const locale = locales[localeKey] || locales.enUS;

  const localDate = fromZonedTime(new Date(isoString), timeZone);
  return format(localDate, 'PPpp', { locale });
}
